import { Icon, IconProps } from '@chakra-ui/react';

export const PrevIcon = (props: IconProps) => (
  <Icon width='5px' height='9px' viewBox='0 0 5 9' fill='black' {...props}>
    <path d='M5 1.28571L1.875 4.5L5 7.71429L4.375 9L0 4.5L4.375 0L5 1.28571Z' fill='inherit' />
  </Icon>
);
